<template>
  <a-modal
      title="带队成员"
      :visible="visible"
      width="450px"
      @ok="handleSubmit"
      okText="提交数据报送审核"
      @cancel="handleCancel"
    >
  <div class="organization">
      <a-form :form="form" class="form" @submit="handleSubmit">
        <div style="position: relative;">
          <upload ref="upload" :length="1" :fixedNumber="[5,7]" :imgs="image" @uploadSuccess="uploadSuccess" :cutImg="true" :uploadTest="'一寸照片'"></upload>
        </div>
        <div>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <a-input addon-before="*姓名" placeholder="姓名" v-decorator="['name', { rules: [{required: true, whitespace:true, message: '请输入姓名'}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <!-- <a-input addon-before="*职称" placeholder="职称" v-decorator="['protitle', { rules: [{required: true, whitespace:true, message: '请输入职称'}]}]"/> -->
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*职称</span>
            <a-select placeholder="选择职称" 
              v-decorator="[
                'protitle',
              ]"
            style="width: 344px" :allowClear="true">
              <a-select-option value="教授">教授</a-select-option>
              <a-select-option value="副教授">副教授</a-select-option>
              <a-select-option value="讲师">讲师</a-select-option>
              <a-select-option value="助教">助教</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*身份类型</span>
            <a-select placeholder="身份类型" 
              v-decorator="[
                'joinType',
              ]"
            style="width: 315px" :allowClear="true">
              <a-select-option value="教师">教师</a-select-option>
              <a-select-option value="学生">学生</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <a-input addon-before="*专业" placeholder="专业" v-decorator="['educational', { rules: [{required: true, whitespace:true, message: '请输入专业'}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <a-input addon-before="*联系电话" placeholder="联系电话" v-decorator="['mobile', { rules: [{required: true, whitespace:true, message: '请输入联系电话'}]}]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <a-input addon-before="*身份证号" placeholder="请输入证件号码" v-decorator="['card', { rules: [{required: true, whitespace:true, message: '请输入请输入证件号码'}]}]"/>
          </a-form-item>
          <!-- <a-form-item
            style="margin-bottom:5px;"
                :wrapperCol="wrapperCol"
            >
              <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*出生年月</span>
              <a-date-picker v-decorator="['birthday', {rules: [{ type: 'object', required: false, message: '请选择出生年月!' }]}]" />
            </a-form-item> -->
            <a-form-item
            style="margin-bottom:5px;"
                :wrapperCol="wrapperCol"
            >
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;margin-right: 20px;">*性别</span>
              <a-radio-group v-decorator="['sex', {rules: [{ required: true, message: '请选择性别!' }]}]">
                <a-radio :value="1">
                  男
                </a-radio>
                <a-radio :value="2">
                  女
                </a-radio>
              </a-radio-group>
            </a-form-item>
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*人员类别</span>
            <a-select placeholder="选择职务类型" style="width: 315px" :allowClear="true" v-model="valData.type">
              <a-select-option v-for="(item, index) in leaders" :value="item.code" :key="index">{{ item.name.indexOf('教练') > -1 ? '教练' : item.name }}</a-select-option>
            </a-select>
          </a-form-item>
          
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*培训证书有效期</span>
            <a-date-picker style="width: 273px" v-model="valData.validityDate" @change="validityDateChange" placeholder="请选择培训证书有效期"/>
          </a-form-item>
          
          <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
            <div v-for="(item,index) in uploadImgList" :key="index" style="width: 150px;float: left;text-align: center;">
              <a-upload
                name="file"
                :action="imgurl"
                listType="text"
                :showUploadList="false"
                @change="handleChangeImage($event, item.value)"
              >
                <div>
                  <img v-if="valData[item.value]" :src="valData[item.value]" style="width:32px;height:32px;">
                  <img v-else src="@comm/assets/img.png">
                  <div class="ant-upload-text">{{ item.name }}</div>
                </div>
              </a-upload>
            </div>
          </a-form-item>
        </div>
      </a-form>
    
  </div>
</a-modal>
</template>

<script>
import store from '@/store'
import address from '@comm/config/address'
import Upload from '@comm/upload/Upload'
import matchFun from '@comm/utils/matchFun'
import {checkIdCard, getBirthday, getSex} from '@comm/utils/IdCardUtils'
import { mapState } from 'vuex'
import config from '@comm/http/config'
export default {
  name: 'EditStaff',
  components: {
    Upload
  },
  data () {
    return {
      imgurl: config.baseImgURL,
      matchFun: matchFun,
      title: '创建单位信息',
      visible: false,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      data: null,
      agencyId: null,
      image: [],
      address: address,
      matchInfo: store.getters['match/matchInfo'],
      programId: Number(this.$route.query.programId),
      valData: {
        id: null,
        type: undefined,
        validityDate: null,
        certificate: null,
        workImg: null,
        cardImg: null,
        cardBankImg: null
      },
      uploadImgList: [{
        name: '培训合格证书',
        value: 'certificate'
      }, {
        name: '工作证',
        value: 'workImg'
      }, {
        name: '身份证正面',
        value: 'cardImg'
      }, {
        name: '身份证反面',
        value: 'cardBankImg'
      }],
      leaders: {},
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  mounted () {
  },
  methods: {
    show(item, agencyId){
      this.leaders = JSON.parse(this.matchInfo.staffData)
      this.agencyId = agencyId
      if (item !== null) {
        this.image = [this.matchFun.randomNumFile('image.jpg', item.image)]
        this.valData = {
          id: item.id,
          type: item.type,
          validityDate: item.validityDate,
          certificate: item.certificate,
          workImg: item.workImg,
          cardImg: item.cardImg,
          cardBankImg: item.cardBankImg
        }
        setTimeout(() => {
          this.form.setFieldsValue({
            name: item.name,
            card: item.card,
            sex: item.sex,
            mobile: item.mobile,
            protitle: item.protitle,
            joinType: item.joinType,
            educational: item.educational
          })
        })
      
        // console.log(this.valData,  111)
      } else {
        this.image = []
        this.valData = {
          id: null,
          type: undefined,
          validityDate: null,
          certificate: null,
          workImg: null,
          cardImg: null,
          cardBankImg: null
        }
        setTimeout(() => {
          this.form.setFieldsValue({
            name: '',
            card: '',
            sex: '',
            protitle: '',
            joinType: '',
            educational: ''
          })
        })
      }
      this.visible = true
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // 去掉名称中的空格
          values.name = values.name.replace(/\s/g, '')
          if (!matchFun.phoneFun(values.mobile)) {
            this.$message.error('手机号码不正确')
            return
          }
          if (this.image.length === 0) {
            this.$message.error('请上传寸件照')
            return
          }
          values.image = this.image[0].url
          values = Object.assign({}, values, this.valData)
          values.agencyId = this.agencyId
          if (values.card && checkIdCard(values.card)) {
            values.birthday = getBirthday(values.card)
            values.sex = getSex(values.card)
          } else {
            values.birthday = new Date()
          }
          this.register(values)
        }
      })
    },
    register (valData) {
      console.log(valData)
      this.$api.match.staffMsgSave(valData).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
          this.handleCancel()
          this.$emit('ok', 0)
        } else {
          this.$message.warn(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    uploadSuccess (e) {
      this.image = e
    },
    handleChangeImage (info, item) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (fileList[0].response) {
        this.valData[item] = fileList[0].response.data.url
        console.log(this.valData)
        this.$forceUpdate()
      }
    },
    validityDateChange (date, dateString) { // 日期选择器
      this.valData.validityDate = dateString
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.organization{
  .title{
    color: #000;
    line-height: 50px;
    font-size: 16px;
    position: relative;
    .add-right-warp{
      position: absolute;
      right: 0;
      top: 0;
    }
    .add-right{
      display: inline-block;
      cursor: pointer;
      color: #000;
      border-radius: 2px;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      padding: 0 10px;
      border: 1px solid #e8e8e8;
    }
  }
  .list{
    .col{
      margin-bottom: 30px;
      float: left;
      width: 50%;
      &:nth-child(odd){
        .warp{
          margin-left: 3%;
        }
      }
    }
    .warp{
      width: 97%;
      height: 120px;
      border:1px solid #e8e8e8;
      border-radius: 2px;
      display: flex;
      flex-direction: row;
      position: relative;
      background-color:#fff;
      box-shadow: rgba(196, 196, 196, 0.5) 1px 1px 3px 1px;
      &:hover{
        cursor: pointer;
        background-color: #f7f7f7;
      }
      .or-img{
        width: 110px;
        height: 110px;
        border-radius: 50%;
        margin-top: auto;
        margin-bottom: auto;
        padding: 10px;
      }
      .content{
        height: 100%;
        display: flex;
        flex-direction: column;
        div{
          flex: 1;
          color: #000;
          line-height: 40px;
          margin-bottom: 0;
          .or-title{
            color: #999;
          }
        }
      }
      .check{
        position: absolute;
        right: 0;
        color: #fff;
        width: 80px;
        font-size: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background-color: #e8e8e8;
      }
    }
    .active{
      .check{
        background-color: red;
      }
    }
  }
}
.organization /deep/ .ant-select-selection{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
.organization /deep/ .ant-cascader-input{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
.organization /deep/ .ant-calendar-picker-input{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/join/joinFactory/EditStaff.vue